export default __webpack_public_path__ + "static/media/tennis.3a5bdf5a.svg";